import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { TablepagedComponent, ColumnDef } from '../../../containers/table/tablepaged/tablepaged.component';
import {  FormAddConfig } from "../../../containers/form/formadd/formadd.component";
import {  FormUpdateConfig } from "../../../containers/form/formupdate/formupdate.component";
import { UpdateAddTableComponent, AttributeDefinition, InputType } from "../../basic/update-add-table/update-add-table.component";

@Component({
  selector: 'app-usergroup',
  imports: [UpdateAddTableComponent],
  templateUrl: './usergroup.component.html',
  styleUrl: './usergroup.component.scss',
})
export class UsergroupComponent {
title = 'Auth user groups';
description = "This are the user groups of the App";
path = "/auth/usergroup";
showFormAdd = true
element_name="usergroup";
showUpdateButton = true;
showDeleteButton = true;

config: Array<AttributeDefinition> = [
{ title: 'Id',               store_key: 'Id' },
{ title: 'IdUserCreation',   store_key: 'IdUserCreation', hidden: true},
{ title: 'TimeCreation',     store_key: 'TimeCreation' , hidden: true},
{ title: 'Name',             store_key: 'Name' },
{ title: 'Description',      store_key: 'Description' },
{ title: 'User',             store_key: 'User.Name' , type: InputType.select,  options_path: "/auth/user"},
{ title: 'Group',            store_key: 'Group.Name' , type: InputType.select, options_path: "/auth/group"}
];

@ViewChild(TablepagedComponent) table!: TablepagedComponent;

}
